export function prefetchRoute(path: string) {
    if (path.startsWith("/app/dashboard")) void import("./dashboard");
    else if (path.startsWith("/app/calendar")) void import("./calendar");
    else if (path.startsWith("/app/waiting-room")) void import("./waiting-room");
    else if (path.startsWith("/app/reception")) void import("./reception");
    else if (path.startsWith("/app/inbox")) void import("./inbox");
    else if (path.startsWith("/app/tickets")) void import("./tickets");
    else if (path.startsWith("/app/ai-phone")) void import("./ai-phone");
    else if (path.startsWith("/app/triage")) void import("./triage");
    else if (path.startsWith("/app/patients")) void import("./patients");
    else if (path.startsWith("/app/billing")) void import("./billing");
    else if (path.startsWith("/app/tasks")) void import("./tasks");
    else if (path.startsWith("/app/analytics")) void import("./analytics");
    else if (path.startsWith("/app/recall")) void import("./recall");
    else if (path.startsWith("/app/follow-ups")) void import("./follow-ups");
    else if (path.startsWith("/app/schedule")) void import("./schedule");
    else if (path.startsWith("/app/referrals")) void import("./referrals");
    else if (path.startsWith("/app/care-requests")) void import("./care-requests");
    else if (path.startsWith("/app/netzwerk")) void import("./netzwerk");
    else if (path.startsWith("/app/settings")) void import("./settings");
    else if (path.startsWith("/app/visits/pending-approvals"))
        void import("./visits/pending-approvals");
}
